(() => {
  const MESSAGE_SELECTOR = '.mp-hide-price-access-control-message';
  const config = window.StarkThemeConfig?.hidePrice || {};
  const CONTACT_PATH = config.contactUrl || '/pages/contacto';
  const CONTACT_LABEL = config.contactLabel || 'Contáctanos';
  const CONTACT_ARIA_TEMPLATE = config.ariaTemplate || '[etiqueta] por este producto';

  const normalizeText = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  const isContactMessage = (message) => {
    if (
      message.querySelector(
        '.mp-hide-price-whatsapp-button, .mp-hide-price-call-button, [data-item="secondary-button"]'
      )
    ) {
      return false;
    }

    const text = normalizeText(message.textContent || '');
    return text.includes('contactanos') || text.includes('contact us');
  };

  const enhanceMessage = (message) => {
    if (message.querySelector('.stark-hide-price__contact') || !isContactMessage(message)) return;

    const productCard = message.closest('.stark-product-card');
    if (productCard) {
      const productForm = productCard.querySelector('product-form-component');
      if (productForm) productForm.append(message);
    }

    const link = document.createElement('a');
    link.className = 'button stark-hide-price__contact';
    link.href = CONTACT_PATH;
    link.textContent = CONTACT_LABEL;
    link.setAttribute('aria-label', CONTACT_ARIA_TEMPLATE.replace('[etiqueta]', CONTACT_LABEL));

    message.replaceChildren(link);

    const stickyBar = message.closest('sticky-add-to-cart');
    if (stickyBar) stickyBar.classList.add('stark-hide-price--active');
  };

  const enhanceHidePriceMessages = (root = document) => {
    if (root instanceof Element && root.matches(MESSAGE_SELECTOR)) enhanceMessage(root);
    root.querySelectorAll?.(MESSAGE_SELECTOR).forEach(enhanceMessage);
  };

  document.addEventListener('hidePriceRulesUpdated', () => {
    requestAnimationFrame(() => enhanceHidePriceMessages());
  });
  document.addEventListener('shopify:section:load', (event) => enhanceHidePriceMessages(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) enhanceHidePriceMessages(node);
      });
    });
  });

  const start = () => {
    enhanceHidePriceMessages();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

